import React from 'react'
import PropTypes from 'prop-types'

export const Alert = props => {
  return (
    <div className="alert-container">
      <div className={`alert alert-${props.bootstrapClass}`}>
        {props.message}
      </div>
    </div>
  )
}

Alert.propTypes = {
  message: PropTypes.string,
  bootstrapClass: PropTypes.string,
}

